import React, { useState } from "react";
import FaIcon from "../components/FaIcon";
import { faEye, faEyeSlash } from "@fortawesome/pro-light-svg-icons";
import { FormFieldProps } from "../components/FormFields/FormFieldProps";

export default function (props: Partial<FormFieldProps>) {
  const [type, setType] = useState<"password" | "text">("password");

  const icon = type == "text" ? faEyeSlash : faEye;

  return (
    <div className="w-full [&_input]:w-full [&_.anticon]:!-ml-[70px]">
      <input
        autoComplete={props.autocomplete}
        disabled={props.disabled}
        id={props.id}
        placeholder={props.placeholder}
        type={type}
        value={props.value}
        onChange={props.onChange}
      />
      <FaIcon icon={icon} size={"lg"} onClick={() => setType(() => (type == "text" ? "password" : "text"))} />
    </div>
  );
}
